@if (isCcvRequired && isSelected()) {
<!-- CVV -->
<input-wrap class="mui-input-no-padding"
            [messages]="checkoutFormComponent?.dataError"
            [canShowValidate]="!!(checkoutFormComponent?.dataError && checkoutFormComponent?.dataError['cvv'])">
    <input class="input"
           placeholder="CVV"
           type="text"
           pattern="[0-9]*"
           inputmode="numeric"
           name="{{cardCode}}"
           data-cs-mask
           required
           minlength="3"
           maxlength="4"
           autocomplete="off"
           [muiInput]="'CVV'"
           [(ngModel)]="cvc"
           [validateDataError]="checkoutFormComponent?.dataError"
           [validateDataErrorKey]="'cvv'" />
</input-wrap>
}